module.exports = __webpack_public_path__ + "static/logo1-2f26305e6270690b8667062f83fa896a.png";